import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { HasFieldViolations } from '@/App/apiWrapper';
import { individualHoroscopeThunk } from '@/features/horoscope/horoscopeSlice';
import { createLabelThunk, deleteLabelThunk, updateLabelThunk } from '@/features/label/labelSlice';
import { createPersonThunk, deletePersonThunk, updatePersonThunk } from '@/features/people/peopleSlice';
import { getPersonThunk } from '@/features/person/personSlice';
import { changePasswordThunk } from '@/features/user/changePassword/changePasswordSlice';
import { deleteUserProfileThunk } from '@/features/user/deleteProfile/deleteProfileSlice';
import { forgotPasswordThunk } from '@/features/user/forgotPassword/forgotPasswordSlice';
import { registerUserThunk } from '@/features/user/register/registerSlice';
import { resetPasswordThunk } from '@/features/user/resetPassword/resetPasswordSlice';
import { deleteCurrentUserAccountThunk, updateCurrentUserPersonalInfoThunk } from '@/features/user/userSlice';
import { initialState, ViolationState } from '@/features/violations';
import { groupBy } from '@/helpers/groupBy';

const handleViolations = (state: ViolationState, action: PayloadAction<HasFieldViolations>) => {
  state.map = groupBy(action.payload.violations, 'fieldId');
};

export const violationsSlice = createSlice({
  name: 'violations',
  initialState,
  reducers: {
    setViolations: (state, action: PayloadAction<HasFieldViolations>) => {
      handleViolations(state, action);
    },
    resetViolations: (state, _: PayloadAction) => {
      Object.assign(state, initialState);
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(individualHoroscopeThunk.fulfilled, (state, action) => {
        handleViolations(state, action);
      })
      .addCase(registerUserThunk.fulfilled, (state, action) => {
        handleViolations(state, action);
      })
      .addCase(forgotPasswordThunk.fulfilled, (state, action) => {
        handleViolations(state, action);
      })
      .addCase(resetPasswordThunk.fulfilled, (state, action) => {
        handleViolations(state, action);
      })
      .addCase(changePasswordThunk.fulfilled, (state, action) => {
        handleViolations(state, action);
      })
      .addCase(updateCurrentUserPersonalInfoThunk.fulfilled, (state, action) => {
        handleViolations(state, action);
      })
      .addCase(createPersonThunk.fulfilled, (state, action) => {
        handleViolations(state, action);
      })
      .addCase(getPersonThunk.fulfilled, (state, action) => {
        handleViolations(state, action);
      })
      .addCase(updatePersonThunk.fulfilled, (state, action) => {
        handleViolations(state, action);
      })
      .addCase(deletePersonThunk.fulfilled, (state, action) => {
        handleViolations(state, action);
      })
      .addCase(createLabelThunk.fulfilled, (state, action) => {
        handleViolations(state, action);
      })
      .addCase(updateLabelThunk.fulfilled, (state, action) => {
        handleViolations(state, action);
      })
      .addCase(deleteLabelThunk.fulfilled, (state, action) => {
        handleViolations(state, action);
      })
      .addCase(deleteCurrentUserAccountThunk.fulfilled, (state, action) => {
        handleViolations(state, action);
      })
      .addCase(deleteUserProfileThunk.fulfilled, (state, action) => {
        handleViolations(state, action);
      });
  },
});

export const { setViolations, resetViolations } = violationsSlice.actions;

export default violationsSlice.reducer;
